export default __webpack_public_path__ + "static/media/firasans-semibold.ad049bf6.woff";